export default function setModalClearSale(result){
    const { code, error } = result;
    const { errorCode } = error;
    return {
        ...result,
        code: code,
        error: {
          errorCode,
          warning: {
            disableCloseButton:true,
            id: "dados-nao-encontrados-celular",
            title: "Dados não aprovados",
            message: "<strong>Lembre-se:</strong> você precisa informar os <strong>dados que sempre utiliza em outras plataformas</strong> como: redes sociais, bancos, compras online ou sites do governo.<br/><br/><strong>Caso esses dados principais não tenham dado certo</strong>, direcione-se à um <a href='https://www.claro.com.br/atendimento/fale-com-a-claro' target='_blank'><strong>canal de atendimento</strong></a>.",
            buttons: [
            {
                    "data-gtm-event-action": "clique:botao:modal",
                    "data-gtm-event-category": "claro:cadastro:clear-sale",
                    "data-gtm-event-label": "dados-nao-encontrados-celular:tentar-novamente",
                    label: "Tentar novamente",
              },
              {
                "data-gtm-event-action": "clique:botao:modal",
                "data-gtm-event-category": "claro:cadastro:clear-sale",
                "data-gtm-event-label": "dados-nao-encontrados-celular:canal-de-atendimento",
                label: "Canal de atendimento",
                className: 'mdn-Button mdn-Button--secondary Button-md',
                onClick: () => {
                  window.open(
                    "https://www.claro.com.br/atendimento",
                    "_blank"
                  );
                },
              },

            ],
          },
        },
      };  
}